// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1aBjA","insightsList":"newBusinessInsightsMenu_insightsList__3TdKo","active":"newBusinessInsightsMenu_active__GvmXT"};